import { render } from "./PartnerTradesView.vue?vue&type=template&id=aef5d4a6&scoped=true"
import script from "./PartnerTradesView.vue?vue&type=script&lang=js"
export * from "./PartnerTradesView.vue?vue&type=script&lang=js"

import "./PartnerTradesView.vue?vue&type=style&index=0&id=aef5d4a6&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef5d4a6"]])

export default __exports__